var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"bar-top-page px-4"},[_c('div',{staticClass:"bar-top-page-row"},[_c('div',{staticClass:"bar-top-page-left"},[(_vm.showBackIcon)?_c('ArrowLeftBack'):_vm._e(),_c('h3',{staticClass:"h3 text-primary font-semi-bold m-0"},[_vm._v(_vm._s(_vm.title))])],1),_c('div',{staticClass:"bar-top-page-right"},[_vm._t("right-area")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }